import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { Paths } from "@routes/paths";
import { type EditLimitedCartDiscountButtonProps } from "./edit-limited-cart-discount-button.interface";

export const EditLimitedCartDiscountButton = ({
	limitedCartDiscountId,
	className,
}: EditLimitedCartDiscountButtonProps) => {
	const navigate = useNavigate();
	const { t } = useTranslation("common");

	return (
		<Button
			icon="pi pi-pencil"
			tooltip={t("order.edit")}
			className={className}
			onClick={() => {
				navigate(Paths.cartDiscounts.withId(limitedCartDiscountId).edit.path);
			}}
		/>
	);
};
